import React, { useState } from 'react';
import Emoji1 from '../../assets/svg/emojis/E1.svg';
import Emoji2 from '../../assets/svg/emojis/E2.svg';
import Emoji3 from '../../assets/svg/emojis/E3.svg';
import Emoji4 from '../../assets/svg/emojis/E4.svg';
import Emoji5 from '../../assets/svg/emojis/E5.svg';
import styles from './select-emoji.module.css';

interface SelectEmojiProps {
	value?: number;
	onChange?: (selected: { rating: number; extra?: string }) => void;
}

interface EmojiOption {
	rating: number;
	label: string;
}

const emojiOptions: EmojiOption[] = [
	{ rating: 1, label: Emoji1 },
	{ rating: 2, label: Emoji2 },
	{ rating: 3, label: Emoji3 },
	{ rating: 4, label: Emoji4 },
	{ rating: 5, label: Emoji5 },
];

const SelectEmoji: React.FC<SelectEmojiProps> = ({ value, onChange }) => {
	const [selected, setSelected] = useState<number | null>(value || null);

	const handleSelect = (rating: number) => {
		setSelected(rating);
		if (onChange) {
			onChange({ rating });
		}
	};

	return (
		<div className={styles.container}>
			<div className={styles.emojiRow}>
				{emojiOptions.map((option) => (
					<div
						key={option.rating}
						onClick={() => handleSelect(option.rating)}
						className={`${styles.emojiOption} ${
							selected === option.rating ? styles.selected : ''
						}`}
						data-cy="emoji-option"
					>
						<img
							src={option.label}
							alt={`Emoji rating ${option.rating}`}
							className={styles.emojiImg}
						/>
						<span className={styles.rating}>{option.rating}</span>
					</div>
				))}
			</div>
		</div>
	);
};

export default SelectEmoji;
